module.exports = __webpack_public_path__ + "media/images/sp/brands/common/main-visual-142aff6256421fd8d02f09e254bfa1e8.jpg";